// extracted by mini-css-extract-plugin
module.exports = {"date-output":"styles_date-output__2SmFU","dateOutput":"styles_date-output__2SmFU"};